import {
  AUTH_SET_KEYS,
  LOCATION_FETCH_FAIL,
  MESSAGE_SEND,
  SET_IS_AWAITING_MESSAGE,
  SET_MESSAGES_TO_SEND
} from '@redux/actions/types'

const initialState = {
  hash: null,
  isAwaitingMessage: false,
  isAwaitingLocation: false,
  messagesToSend: []
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case AUTH_SET_KEYS:
    if (payload.hash) {
      return {
        ...state,
        hash: payload.hash
      }
    } else {
      return {
        ...state
      }
    }
  case LOCATION_FETCH_FAIL:
    return {
      ...state,
      isAwaitingLocation: false
    }
  case SET_IS_AWAITING_MESSAGE:
    return {
      ...state,
      isAwaitingMessage: payload
    }
  case SET_MESSAGES_TO_SEND:
    return {
      ...state,
      messagesToSend: payload,
      isAwaitingMessage: true
    }
  case MESSAGE_SEND:
    return {
      ...state,
      isAwaitingMessage: true
    }
  default:
    return state
  }
}

export default reducer
